"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.md5 = md5;
var _md = _interopRequireDefault(require("crypto-js/md5"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function md5(value) {
  return (0, _md.default)(String(value)).toString();
}